import { Button, Paper, Stack, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import CannotDoFaceCheckOption from '../CannotDoFaceCheckOption';
import AcceptedSection from './AcceptedSection';
import UnacceptedSection from './UnacceptedSection';

export interface StartScreenWithGuideProps {
  dataTestId: string;
  onStart: () => void;
  onSkip?: () => void;
  isEnableOptions?: boolean; // whether to show the CannotDoFaceCheckOption (skip) entry
}

export default function StartScreenWithGuide({
  dataTestId,
  onStart,
  onSkip,
  isEnableOptions = true,
}: Readonly<StartScreenWithGuideProps>) {
  return (
    <Paper data-testid={dataTestId}>
      <Stack gap={tokens.spacingLg} padding={tokens.spacingBase}>
        <Typography variant="h5" textAlign="center" data-component="header">
          Get ready for your face check
        </Typography>

        <AcceptedSection dataTestId={`${dataTestId}-accepted`} />
        <UnacceptedSection dataTestId={`${dataTestId}-unaccepted`} />

        <Stack justifyContent="center" alignItems="center" gap={tokens.spacingLg}>
          <Button
            variant="contained"
            onClick={onStart}
            sx={{ width: ['100%', 'auto'] }}
            size="large"
          >
            START FACE CHECK
          </Button>
          {isEnableOptions && onSkip && <CannotDoFaceCheckOption onSkip={onSkip} />}
        </Stack>
      </Stack>
    </Paper>
  );
}
